import { Client } from "./client";
import { Contact } from "./contact";
import { EUserRole } from "./enum/user-role";

export class User {
    Id!:number;
    Email!: string;
    Password!: string;
    Phone!: string;
    FirstName!: string;
    LastName!: string;
    Type!: EUserRole;
    IsActive!: boolean;
    ServerKey!: string;
    ClientKey!: string;
    PartnerCode!: string;

    VisibiliteFacture!: boolean;
    CanCreateGestionnaire!:boolean;
    ClientList: Client[] = [];
    ContactList: Contact[] = [];

    static mapFromJSON(json: any) {
        const m = new User();
console.log(json);
        m.ServerKey = json['serverKey'];
        m.ClientKey = json['clientKey'];
        m.Id=json['id'];
        m.PartnerCode = json['partnerCode'];
        m.Type = json['type'];
        m.FirstName = json['firstName'];
        m.LastName = json['lastName'];
        m.Phone = json['phone'];
        m.Email = json['email'];
        m.IsActive = json['isActive'];
        m.VisibiliteFacture = json['visibiliteFacture'];
        m.CanCreateGestionnaire = json['canCreateGestionnaire'];
        
        if (json['clientList']) {
            m.ClientList = json['clientList'].map((item: any) => Client.mapFromJSON(item));
        }
        if (json['contactList']) {
            m.ContactList = json['contactList'].map((item: any) => Contact.mapFromJSON(item));
        }
        return m;
    }
}
